import React from 'react'
import { NavigateFunction, useNavigate } from 'react-router-dom'

import { reduxForm } from 'redux-form/immutable'

import styles from './editPracticeInfo.module.scss'
import PracticeInfoForm from '../../../common/components/forms/practiceInfo/PracticeInfoForm'
import practiceInfoValidate from '../../../common/components/forms/practiceInfo/practiceInfoValidate'
import { PRACTICES_DETAILS_INFO } from '../../../common/constants/routingConstants'

type Props = {
  handleSubmit?: (...args: any[]) => any
  submitting?: boolean
  navigate: NavigateFunction
}

class EditPracticeInfo extends React.Component<Props> {
  _submitForm = (_: any) => {
    this.props.navigate(PRACTICES_DETAILS_INFO.route, { replace: true })
  }

  render() {
    const { handleSubmit, submitting } = this.props

    return (
      <div className={styles['content-container']}>
        <h2 className={styles.title}>Edit Practice Info</h2>

        <PracticeInfoForm
          handleSubmit={handleSubmit}
          submitFunction={this._submitForm}
          submitting={submitting}
          showEmailField
          primaryButtonText='Save'
        />
      </div>
    )
  }
}

const ConnectedEditPracticeInfo = reduxForm({
  form: 'editPracticeInfoForm',
  validate: practiceInfoValidate,
  touchOnBlur: false,
  // @ts-expect-error TS(2345): Argument of type 'typeof EditPracticeInfo' is not ... Remove this comment to see the full error message
})(EditPracticeInfo) as unknown as React.ComponentType<{
  navigate: NavigateFunction
  initialValues?: any
}>

export default function EditPracticeInfoWithRouter(props: { initialValues?: any }) {
  const navigate = useNavigate()
  return <ConnectedEditPracticeInfo {...props} navigate={navigate} />
}
